import { fExecuteAPI } from "../../Server/Apis";
import {
  InventoryPhysicalstock_saveHead_API,
  InventoryPhysicalstock_gridLoad_API,
  InventoryPhysicalstock_saveDetail_API,
  InventoryPhysicalstock_save_API,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import moment from "moment";
import { vRdxUserInfo, PhysicalStockRo } from "../../Redux/roStore";
import {
  Set_SlicePhysicalStock_HeadObj,
  Set_SlicePhysicalStock_HeadObject_SheetNo_A_DocStat,
} from "./SlicePhysicalStock";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Barcode: "",
  B_Itmcd: "",
  B_ItmName: "",
  B_BinCode: "",
  B_BinName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "IPT01";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    "SEARCHEXACTITEM_GETROW001",
    FinalObj
  );
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      SuppRefNo1: vItemSearchFull[0].SuppRefNo1,
      B_Qty: vItemSearchFull[0].Qty,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === vItemSearchFull[0].DefUnit;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
      // let vItemUnitSet = currentUnitArr.find((obj) => {
      //   return obj.Unit === vItemSearchFull[0].DefUnit;
      // });
      // if (!!vItemUnitSet) {
      //   setBufferObj((obj) => ({
      //     ...obj,
      //     B_Unit: vItemUnitSet.Unit,
      //     B_UnitName: vItemUnitSet.Name1,
      //     B_PackQty: vItemUnitSet.PackQty,
      //   }));
      // } else {
      //   let vItemUnitSet = currentUnitArr.find((obj) => {
      //     return obj.Unit === vItemSearchFull[0].PurUOM;
      //   });
      //   if (!!vItemUnitSet) {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: vItemUnitSet.Unit,
      //       B_UnitName: vItemUnitSet.Name1,
      //       B_PackQty: vItemUnitSet.PackQty,
      //     }));
      //   } else {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: currentUnitArr[0].Unit,
      //       B_UnitName: currentUnitArr[0].Name1,
      //       B_PackQty: currentUnitArr[0].PackQty,
      //     }));
      //   }
      // }
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="103"]');
      element.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0].focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
  if (
    vRdxHead.SheetNo === "" ||
    vRdxHead.SheetNo === null ||
    vRdxHead.SheetNo === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      SheetNo: "Sheet Number should not be empty",
    }));

    iRes = false;
  }

  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, Loc: "Location should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.Date === "" ||
    vRdxHead.Date === null ||
    vRdxHead.Date === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      Date: "Date should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.ReferenceNo === "" ||
    vRdxHead.ReferenceNo === null ||
    vRdxHead.ReferenceNo === undefined ||
    vRdxHead.ReferenceNo <= 0
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      ReferenceNo: "ReferenceNo should not be Empty",
    }));
    iRes = false;
  }

  if (vRdxHead.A_DocStat !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Barcode === "" ||
    sBufferObj.B_Barcode === null ||
    sBufferObj.B_Barcode === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Barcode: "Barcode should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};
//API SaveSIHead
// const fSaveHead = async (xSave, fNewDetail, sBufferObj, dispatch) => {
//   const vRdxUserInfoObj = vRdxUserInfo();
//   const { HeadObj } = PhysicalStockRo();
//   const iStatus = xSave ? HeadObj.A_DocStat : "POST"; //xSave False means Post
//   let vSaveSIHeadObj = {
//     A_SheetId: HeadObj.SheetNo,
//     A_Loc: HeadObj.Loc,
//     A_Date: moment(HeadObj.Date).format("MM/DD/YYYY"),
//     A_Status: iStatus,
//     A_RefNo: HeadObj.ReferenceNo,
//     UserCd: vRdxUserInfoObj.UserID,
//     IP: vRdxUserInfoObj.IP,
//   };
//   let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
//   const vSaveSIHead = await InventoryPhysicalstock_saveHead_API(FinalObj);
//   if (vSaveSIHead?.status === 200) {
//     dispatch(
//       Set_SlicePhysicalStock_HeadObject_SheetNo_A_DocStat({
//         SheetNo: xSave
//           ? vSaveSIHead?.data?.ResultSet[0]?.SheetId
//           : HeadObj.SheetNo,
//         A_DocStat: iStatus,
//       })
//     );

//     //approve bool type false
//     if (!xSave) {
//       fAlertToast("SUCCESS", "Successfully posted");
//     } else {
//       fSaveDetail(sBufferObj, fNewDetail);
//     }
//   } else if (vSaveSIHead?.Type?.toUpperCase() === "FAILED") {
//     fAlertToast("FAILED", vSaveSIHead.Status);
//   } else {
//     fAlertToast(
//       "FAILED",
//       !!vSaveSIHead.response.data.Status
//         ? vSaveSIHead?.response?.data?.Status
//         : "Fail to Save Head"
//     );
//   }
// };

// const fSaveDetail = async (sBufferObj, fNewDetail) => {
//   const { HeadObj } = PhysicalStockRo();

//   let vSaveSIDetailObj = {
//     v_B_SheetId: HeadObj.SheetNo,
//     v_B_SrNo: sBufferObj.B_Srno,
//     v_B_Barcode: sBufferObj.B_Barcode,
//     v_B_ItmCd: sBufferObj.B_Itmcd,
//     v_B_Qty: sBufferObj.B_Qty,
//     v_B_Unit: sBufferObj.B_Unit,
//     v_B_RefNo: sBufferObj.SuppRefNo1,
//   };
//   let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
//   const vSaveSIDetail = await InventoryPhysicalstock_saveDetail_API(FinalObj);
//   if (vSaveSIDetail?.status === 200) {
//     fNewDetail();
//     fAlertToast("SUCCESS", "Successfully Saved");
//   }
// };

const fSaveApi = async (xSave, sBufferObj, dispatch, setDetail_Grid_Row) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = PhysicalStockRo();
  const iStatus = xSave ? HeadObj.A_DocStat : "POST"; //xSave False means Post
  let vSaveSIHeadObj = {
    A_SheetId: HeadObj.SheetNo,
    A_Loc: HeadObj.Loc,
    A_Date: moment(HeadObj.Date).format("MM/DD/YYYY"),
    A_Status: iStatus,
    A_RefNo: HeadObj.ReferenceNo,
    UserCd: vRdxUserInfoObj.UserID,
    IP: vRdxUserInfoObj.IP,
    B_SrNo: sBufferObj.B_Srno,
    B_Barcode: sBufferObj.B_Barcode,
    B_ItmCd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    TrnTyp: "IPT01",
    v_B_RefNo: sBufferObj.shelfNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await InventoryPhysicalstock_save_API(FinalObj);
  if (vSaveSIHead?.status === 200) {
    const newSheetId = vSaveSIHead?.data?.ResultSet?.SheetId;
    dispatch(
      Set_SlicePhysicalStock_HeadObject_SheetNo_A_DocStat({
        SheetNo: newSheetId,
        A_DocStat: iStatus,
      })
    );
    fAlertToast("SUCCESS", "Successfully Saved");
    await fLoad_Grid(newSheetId, setDetail_Grid_Row);
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.data.Status
        ? vSaveSIHead?.data?.Status
        : "Fail to Save Head"
    );
  }
};

const GetSIDetail = async (sheetId) => {
  // const { HeadObj } = PhysicalStockRo();
  let iSIDetailObj = {
    SheetId: sheetId,
    TrnTyp: "IPT01",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await InventoryPhysicalstock_gridLoad_API(FinalObj);
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
const fLoad_Grid = async (sheetId, setDetailGridData) => {
  if (!sheetId) {
    setDetailGridData([]);
    return;
  }

  const iSIDetail = await GetSIDetail(sheetId);

  if (iSIDetail?.length > 0) {
    const GridID = iSIDetail.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveApi,
};
